var map = {
	"./36_sing.mp3": "89b2",
	"./37_catch.mp3": "26cf",
	"./40_run.mp3": "048c",
	"./M_Brilliant.mp3": "59b5",
	"./M_Excellent.mp3": "f377",
	"./M_Fantastic.mp3": "ab7c",
	"./M_Great.mp3": "bafa",
	"./M_Perfect.mp3": "17ba",
	"./M_Think again.mp3": "85cb",
	"./M_Try again.mp3": "d462",
	"./M_Very good.mp3": "f3ec",
	"./M_Well done.mp3": "590b",
	"./M_Work harder.mp3": "89f1",
	"./click.mp3": "b9b5",
	"./false.mp3": "356d",
	"./true.mp3": "d5ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bfd6";